import { faQuoteLeft, faQuoteRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import tw, { styled } from "twin.macro";

import headshotSrc from "../../assets/images/customers/henning.jpg";
import logoSrc from "../../assets/images/customers/hootsuite-white.svg";
import Container from "../common/Container";
import TestimonialBoxDark from "./TestimonialBoxDark";
import TestimonialLayoutStacked from "./TestimonialLayoutStacked";
import { QuoteWithMarksWhite, TestimonialHighlight } from "./TestimonialStyles";

const LogoImage = styled.img`
  @media (max-width: 950px) {
    width: 200px;
  }
`;

const HootsuiteTestimonialDark: React.FunctionComponent = () => (
  <Container>
    <TestimonialBoxDark>
      <TestimonialLayoutStacked
        logo={
          <LogoImage src={logoSrc} alt="Hootsuite" width={232} height={43} />
        }
        quote={
          <QuoteWithMarksWhite>
            <div tw="flex-shrink-0">
              <FontAwesomeIcon
                icon={faQuoteLeft}
                className="fas fa-quote-left"
              />
            </div>
            <div>
              The <TestimonialHighlight>custom branding</TestimonialHighlight>{" "}
              features are super{" "}
              <TestimonialHighlight>
                important to Hootsuite
              </TestimonialHighlight>
              . Custom CSS is easy to add and it’s very straightforward to{" "}
              <span tw="whitespace-nowrap">
                use.
                <FontAwesomeIcon
                  icon={faQuoteRight}
                  className="fas fa-quote-right"
                />
              </span>
            </div>
          </QuoteWithMarksWhite>
        }
        headshot={<img src={headshotSrc} alt="" width={80} height={80} />}
        name="Henning Heinrich"
        jobTitle="Product Growth Team Lead"
      />
    </TestimonialBoxDark>
  </Container>
);

export default HootsuiteTestimonialDark;
